export default __webpack_public_path__ + "static/media/927.177aefe4.png";